/**
 *
 * @module tokenRequestBuilder
 *
 */

import Check from 'check-types';
import TokenRequest from './tokenRequest';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number
} = Check.assert;

/**
 *
 * @class TokenRequestBuilder
 * @desc Interface used to build a token exchange request.
 *
 */
export default class TokenRequestBuilder {

    constructor() {

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the grant type. This must be a
         * valid type that is recognized by the service.
         *
         */
        this.grantType = '';

        /**
         *
         * @access private
         * @type {Object}
         *
         */
        this.tokenData = Object.create(null);

    }

    /**
     *
     * @access public
     * @param {Number} latitude - The latitude of the device.
     * @param {Number} longitude - The longitude of the device.
     * @desc Builds the token request.
     * @returns {Promise<TokenRequest>} Data required to make a token request.
     *
     */
    build(latitude, longitude) {

        const errorMessage = {
            method: 'TokenRequestBuilder.build(latitude, longitude)',
            get latitude() {
                return `${this.method} latitude should be a Number`;
            },
            get longitude() {
                return `${this.method} longitude should be a Number`;
            }
        };

        number(latitude, errorMessage.latitude, InvalidArgumentException);
        number(longitude, errorMessage.longitude, InvalidArgumentException);

        const { grantType, tokenData } = this;

        return Promise.resolve(
            new TokenRequest(grantType, tokenData, latitude, longitude)
        );

    }

}



// WEBPACK FOOTER //
// ./src/services/token/tokenRequestBuilder.js